import { type FC } from 'react';
import { useSsoLogin } from '~/authentication/loginPage/sso/useSsoLogin';
import { RegisterFormComponent } from './registerForm.component';
import { RegisterFormSuccessComponent } from './registerFormSuccess.component';
import { useUserRegister } from './useUserRegister';
import { useUserRegisterFormMessages } from './useUserRegisterMessages';

export const RegisterFormContainer: FC = () => {
  const { registerUser, isLoading } = useUserRegister();
  const { onRegisterSubmit, errors, errorMessage, showSuccessMessage, closeErrorMessage, closeSuccessMessage } = useUserRegisterFormMessages(registerUser);
  const { isLoading: isSsoLoading, onGoogleLogin, onMicrosoftLogin } = useSsoLogin();

  if (showSuccessMessage) {
    return (
      <RegisterFormSuccessComponent onClose={closeSuccessMessage} />
    );
  }

  return (
    <RegisterFormComponent
      closeErrorMessage={closeErrorMessage}
      errorMessage={errorMessage}
      errors={errors}
      isLoading={isLoading || isSsoLoading}
      onGoogleLogin={onGoogleLogin}
      onMicrosoftLogin={onMicrosoftLogin}
      onSubmit={onRegisterSubmit}
    />
  );

};
